import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'h3-annotation-list-section-header',
  templateUrl: './annotation-list-section-header.component.html',
  styleUrls: ['./annotation-list-section-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnnotationListSectionHeaderComponent {
  @Input({ required: true }) label!: string;
}
